/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout, Card, ProgressBar } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { site, app } from 'src/config/';
import { getShop } from 'src/helpers';

import * as syncActions from 'actions/sync-actions';

type Props = {
  getSyncProcessStatus: () => void,
  error: any,
  syncProcessLoading: boolean,
  syncProcessStatus: Object
};

type ComposedProps = Props & WithI18nProps;

type State = {
  syncProcessDot: string,
  percentage: number
};

class Progress extends Component<ComposedProps, State> {
  timeoutGetSyncProcessStatus = undefined;
  intervalProgressDot = undefined;

  state = {
    syncProcessDot: '',
    percentage: 0
  };

  componentDidMount() {
    const { getSyncProcessStatus } = this.props;
    getSyncProcessStatus();
  }

  componentWillReceiveProps(nextProps: Props) {
    const { syncProcessLoading } = nextProps;
    const { syncProcessLoading: syncProcessLoadingPrev } = this.props;

    // Check sync process
    if (syncProcessLoadingPrev && !syncProcessLoading) {
      const { flow, getSyncProcessStatus } = nextProps;
      const { status, completedPercent = 0 } = flow;

      // Status = "done"
      if (status === 'done') {
        // Update percentage
        const percentage = parseInt(completedPercent * 100);
        if (!Number.isNaN(percentage)) {
          this.setState({ percentage });
        }

        // Clear time out interval
        clearInterval(this.intervalProgressDot);

        // Set time out 10s
        // Check migrate done, progress === 1
        if (parseInt(completedPercent) === 1) {
          setTimeout(() => {
            // Go to complete - Reset tenant app, so using window location
            const shop = getShop();
            window.top.location.href = `https://${shop}/admin/apps/${app.apiKey}/plan-migration-complete`;
          }, site.showSyncProgesssTimeout);
        }
      } else {
        // Status = "running" ||"error" || anything else
        // Update percentage
        const percentage = parseInt(completedPercent * 100);
        if (!Number.isNaN(percentage)) {
          this.setState({ percentage });
        }

        // Set interval syncProcessDot
        if (this.intervalProgressDot === undefined) {
          this.intervalProgressDot = setInterval(() => {
            let { syncProcessDot } = this.state;
            syncProcessDot = syncProcessDot === '...' ? '.' : syncProcessDot + '.';
            this.setState({ syncProcessDot });
          }, 500);
        }
      }

      // Set time out to get sync status -- Always run
      this.timeoutGetSyncProcessStatus = setTimeout(() => {
        getSyncProcessStatus();
      }, site.syncStatusTimeout);
    }
  }

  render() {
    const { i18n } = this.props;
    const { syncProcessDot, percentage } = this.state;

    return (
      <Layout.Section>
        <div className="align-center ">
          <Card
            sectioned
            title={`${i18n.translate(
              'AdminHTML.Subscription.PlanMigration.progressTitle'
            )}${syncProcessDot}`}>
            <ProgressBar progress={percentage} />
          </Card>
        </div>
      </Layout.Section>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    error: _.get(state.sync, 'error', undefined),
    syncProcessLoading: _.get(state.sync, 'syncProcessLoading', false),
    flow: _.get(state.sync, 'flow', {})
  };
};

const mapDispatchToProps = dispatch => ({
  // Get sync process status
  getSyncProcessStatus: () => dispatch(syncActions.getSyncProcessStatus('FlowESClusterMigration'))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(Progress));
